export default __webpack_public_path__ + "static/media/13.99752a7b.jpg";